import React from 'react';
import { Navigate, Route, Routes, useSearchParams, useNavigate, useParams } from 'react-router-dom';
import { PageNotFound } from '@components/common';
import {
  ManagementPage,
  LivelensPage,
  WorkflowPage,
  HomePage,
  MetricBuilderPage,
  SemanticMapperPage,
  SensorRemoteControlPage,
  VisualActivationPage,
} from '@src/pages';
import SankeyPage from '@src/emp-3.0/components/Sankey';
import FunnelPage from '@src/emp-3.0/components/Funnel';
import '../styles/index.less';
import { ShareHoc } from '@src/emp-3.0/components/common/Sharing';
import useToFunnelStore from '@src/emp-3.0/components/Sankey/store/toFunnelStore';
const RedirectToHomePage = () => {
  const actualPath = `/home`;
  return <Navigate to={actualPath} />;
};
const SankeyPageComponent = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const params = Object.fromEntries(searchParams.entries()) as any;
  // add try catch to avoid JSON.parse error
  try {
    params.interval = JSON.parse(decodeURIComponent(params.interval));
    params.globalFilter = JSON.parse(decodeURIComponent(params.globalFilter));
  } catch (e) {
    params.globalFilter = {};
  }

  const { id: eventName }: any = useParams();
  return (
    <ShareHoc shareName="sankey">
      <SankeyPage
        {...params}
        eventName={eventName}
        onModalClose={() => {
          // do nothing
          // window.close();
        }}
        onConvertToFunnel={() => {
          navigate(`/funnels`, { state: { from: 'sankey' } });
        }}
      />
    </ShareHoc>
  );
};
const FunnelPageComponent = () => {
  const [searchParams] = useSearchParams();
  const params = Object.fromEntries(searchParams.entries()) as any;
  try {
    params.interval = JSON.parse(decodeURIComponent(params.interval));
    params.globalFilter = JSON.parse(decodeURIComponent(params.globalFilter));
  } catch (e) {
    params.globalFilter = {};
  }
  const { initFunnelPayload } = useToFunnelStore();

  const { id: eventName }: any = useParams();
  return (
    <ShareHoc shareName="funnel">
      <FunnelPage {...params} eventName={eventName} {...initFunnelPayload} />
    </ShareHoc>
  );
};

const App: React.FC = () => {
  const pageNotFoundRenderer = () => <PageNotFound />; // When application is switched in Apphub, history is not updated properly.

  return (
    <Routes>
      <Route path={''} element={RedirectToHomePage()} />
      <Route path={`semantic-mapper`} element={<SemanticMapperPage />} />
      <Route path={`management/*`} element={<ManagementPage />} />
      <Route path={`livelens`} element={<LivelensPage />} />
      <Route path={`metric-builder/*`} element={<MetricBuilderPage />} />
      <Route path={`workflow/*`} key={location.href} element={<WorkflowPage />} />
      <Route path={`home`} element={<HomePage />} />
      <Route path={`paths`} element={<SankeyPageComponent />} />
      <Route path={`paths/:id`} element={<SankeyPageComponent />} />
      <Route path={`funnels`} element={<FunnelPageComponent />} />
      <Route path={`ai`} element={<Navigate to="/home" replace />} />
      <Route path={`visual-activation/*`} element={<VisualActivationPage />} />
      <Route path={`sensor-remote-control/*`} element={<SensorRemoteControlPage />} />
      <Route element={pageNotFoundRenderer()} />
    </Routes>
  );
};

export default App;
